/**
 * Types and mapping for channel-specific AI prompt overrides.
 *
 * Rod's backend (AM-4013) stores overrides per AIConfiguration per channel.
 * The PromptAssembler uses 3 layers: GlobalPrompt → BotPrompt → ChannelOverride.
 */

export type OverrideMode = "replace" | "additive" | "suppress";

export interface ChannelOverride {
  id?: number;
  conversationSource: string;
  mode: OverrideMode;
  overrideText: string;
}

/**
 * Maps admin-side channelDefs keys to Rod's backend conversationSource values.
 * Backend PascalCase; admin camelCase.
 */
export const CHANNEL_SOURCE_MAP: Record<string, string> = {
  web: "Web",
  twilioSms: "TwilioSms",
  twilioIvr: "TwilioIvr",
  whatsApp: "WhatsApp",
  facebook: "Facebook",
  twitter: "Twitter",
  email: "Email",
};

/** Reverse lookup: backend source → admin channel key */
export const SOURCE_CHANNEL_MAP: Record<string, string> = Object.fromEntries(
  Object.entries(CHANNEL_SOURCE_MAP).map(([k, v]) => [v, k])
);

export const OVERRIDE_MODE_LABELS: Record<OverrideMode, { label: string; description: string }> = {
  additive: {
    label: "Additive",
    description: "Append these instructions after the bot's main prompt",
  },
  replace: {
    label: "Replace",
    description: "Use this text instead of the bot's main prompt for this channel",
  },
  suppress: {
    label: "Suppress",
    description: "Remove the bot's main prompt entirely for this channel (global prompt still applies)",
  },
};
